import {SceneComponent} from "../components/scene/scene.component";
import {ImageComponent} from "../components/image/image.component";
import {VideoComponent} from "../components/video/video.component";
import {LabelComponent} from "../components/label/label.component";
import {ButtonComponent} from "../components/button/button.component";
import {ClockComponent} from "../components/clock/clock.component";
import {CameraComponent} from "../components/camera/camera.component";
import {PlaylistComponent} from "../components/playlist/playlist.component";
import {JsonListComponent} from "../components/json-list/json-list.component";
import {JsonItemComponent} from "../components/json-item/json-item.component";
import {JsonViewerComponent} from "../components/json-viewer/json-viewer.component";
import {TextInputComponent} from "../components/text-input/text-input.component";
import {CheckboxComponent} from "../components/checkbox/checkbox.component";
import {CollectionComponent} from "../components/collection/collection.component";
import {NumericStepperComponent} from "../components/numeric-stepper/numeric-stepper.component";
import {CountdownComponent} from "../components/countdown/countdown.component";
import {CustomRssPlayerComponent} from "../components/custom-rss-player/custom-rss-player.component";
import {CustomRssItemComponent} from "../components/custom-rss-item/custom-rss-item.component";
import {CatalogPlayerComponent} from "../components/catalog-player/catalog-player.component";
import {CatalogItemComponent} from "../components/catalog-item/catalog-item.component";
import {ExtAppComponent} from "../components/ext-app/ext-app.component";
import {LabelQueueComponent} from "../components/label-queue/label-queue.component";
import {HtmlComponent} from "../components/html/html.component";
import {RichTextComponent} from "../components/rich-text/rich-text.component";
import {YouTubeComponent} from "../components/you-tube/you-tube.component";
import {RadioComponent} from "../components/radio/radio.component";
import {SwitchComponent} from "../components/switch/switch.component";
import {SliderComponent} from "../components/slider/slider.component";
import {StockTickerComponent} from "../components/stock-ticker/stock-ticker.component";
import {RssComponent} from "../components/rss/rss.component";
import {XmlPlayerComponent} from "../components/xml-player/xml-player.component";
import {XmlItemComponent} from "../components/xml-item/xml-item.component";
import {MessageComponent} from "../components/message/message.component";
import {ExtImageComponent} from "../components/ext-image/ext-image.component";
import {ExtVideoComponent} from "../components/ext-video/ext-video.component";
import {QrComponent} from "../components/qr/qr.component";
import {StockItemComponent} from "../components/stock-item/stock-item.component";
import {KnxComponent} from "../components/knx/knx.component";
import {SerialPortComponent} from "../components/serial-port/serial-port.component";
import {AdNetComponent} from '../components/ad-net/ad-net.component';
import {LoaderComponent} from '../components/Loader/loader.component';
import {LocationBaseComponent} from "../components/location-base/location-base.component";
import {NotSupportedComponent} from "../components/not-supported/not-supported.component";
import {PodcastComponent} from "../components/podcast/podcast.component";
import {ChartComponent} from "../components/chart/chart.component";
import {FormComponent} from "../components/form/form.component";
import {FasterQComponent} from "../components/faster-q/faster-q.component";
import {SchedulerComponent} from "../components/scheduler/scheduler.component";
import {HourlyBalancerComponent} from "../components/hourly-balancer/hourly-balancer.component";
import {FlickingComponent} from "../components/flicking/flicking.component";
import {PttMicComponent} from "../components/ptt/ptt-mic.component";
import {PttSpkComponent} from "../components/ptt/ptt-spk.component";
import {GpsComponent} from "../components/ptt/gps.component";
import {AyreshareComponent} from "../components/ayreshare/ayreshare.component";
import {CanvaComponent} from "../components/Canva/canva.component";
import {MusicComponent} from "../components/music/music.component";
import {MusicListComponent} from "../components/music-list/music-list.component";


export class ComponentClasses {
  releaseClasses = {
    '3100': VideoComponent,
    '3130': ImageComponent,
    '3140': ImageComponent,
    '3145': MusicComponent,
    '3150': ExtVideoComponent,
    '3160': ExtImageComponent,
    '3235': HtmlComponent,
    '3240': RichTextComponent,
    '3241': LabelComponent,
    '3242': LabelQueueComponent,
    '3245': MessageComponent,
    '3270': CatalogItemComponent,
    '3280': CatalogPlayerComponent,
    '3310': NotSupportedComponent,
    '3315': NotSupportedComponent,
    '3320': ClockComponent,
    '3322': CountdownComponent,
    '3335': StockItemComponent,
    '3338': StockTickerComponent,
    '3340': PodcastComponent,
    '3345': RssComponent,
    '3346': CustomRssPlayerComponent,
    '3348': CustomRssItemComponent,
    '3350': CameraComponent,
    '3400': ChartComponent,
    '3410': ExtAppComponent,
    '3415': NotSupportedComponent,
    '3420': AdNetComponent,
    '3430': QrComponent,
    '3510': SceneComponent,
    '3511': SceneComponent,
    '3600': FormComponent,
    '4100': CollectionComponent,
    '4101': FlickingComponent,
    '4102': PlaylistComponent,
    '4103': LoaderComponent,
    '4104': SchedulerComponent,
    '4105': LocationBaseComponent,
    '4110': MusicListComponent,
    '4120': HourlyBalancerComponent,
    '4200': XmlPlayerComponent,
    '4210': XmlItemComponent,
    '4300': JsonListComponent,
    '4305': JsonViewerComponent,
    '4310': JsonItemComponent,
    '4330': JsonListComponent,
    '4400': JsonListComponent,
    '4500': JsonListComponent,
    '4505': JsonItemComponent,
    '4600': YouTubeComponent,
    '5000': SerialPortComponent,
    '5010': KnxComponent,
    '5500': HtmlComponent,
    '5600': CanvaComponent,
    '6000': JsonListComponent,
    '6010': JsonViewerComponent,
    '6020': JsonListComponent,
    '6022': JsonViewerComponent,
    '6030': JsonListComponent,
    '6040': JsonListComponent,
    '6050': JsonListComponent,
    '6060': JsonListComponent,
    '6070': JsonListComponent,
    '6080': JsonListComponent,
    '6090': JsonListComponent,
    '6100': FasterQComponent,
    '6210': JsonListComponent,
    '6220': JsonListComponent,
    '6230': JsonListComponent,
    '6240': JsonListComponent,
    '6250': JsonListComponent,
    '6260': JsonListComponent,
    '6300': AyreshareComponent, // facebook
    '6305': AyreshareComponent, // fbg (facebook groups)
    '6310': AyreshareComponent, // gmb (google business profile)
    '6315': AyreshareComponent, // instagram
    '6320': AyreshareComponent, // linkedin
    '6325': AyreshareComponent, // pinterest
    '6330': AyreshareComponent, // reddit
    '6335': AyreshareComponent, // telegram
    '6340': AyreshareComponent, // tiktok
    '6345': AyreshareComponent, // twitter
    '6350': AyreshareComponent, // youtube
    '6500': JsonViewerComponent,
    '6510': NotSupportedComponent,
    '7000': ButtonComponent,
    '7010': CheckboxComponent,
    '7020': NumericStepperComponent,
    '7030': RadioComponent,
    '7040': SwitchComponent,
    '7050': TextInputComponent,
    '7060': SliderComponent,
    '7100': PttMicComponent,
    '7101': PttSpkComponent,
    '7200': GpsComponent,
    '8000': NotSupportedComponent,
    '9000': NotSupportedComponent
  }
}
